<mat-sidenav-container fullscreen>
    <mat-sidenav-content>
        <app-header></app-header>
        <div class="container">
            <div class="row ">
                <div class="col-center col s12">
                    <div class="">
                        <div class="row" style="margin-top: 40px;">
                            <div class="wallet-toggle">
                                <div class="tab-indicator" [ngClass]="activeTab"></div>
                                <button class="btnlogs" [class.active]="activeTab === 'gateway'"
                                    (click)="setTab('gateway')">
                                    <span>Gateway Payment</span>
                                </button>
                                <button class="btnlogs" [class.active]="activeTab === 'normal'"
                                    (click)="setTab('normal')">
                                    <span>Normal Payment</span>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="isLoading" class="loader-container">
                            <div class="spinner"></div>
                        </div>
                        <div *ngIf="!isLoading" class="bet-history-page bgpagwhite">
                            <div class="commentablewrap ctablepage table-responsive whitespace">
                                <table class="table commen-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">S. No</th>
                                            <th scope="col"> Amount </th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Reason</th>
                                            <th scope="col">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let x of transactions ; let i = index" class="even">
                                            <td class="p-2">{{ i + 1 }}</td>
                                            <td class="p-2">{{ x?.amount }}</td>
                                            <td class="p-2 flex items-end">
                                                <div class="badgebox">
                                                    <div *ngIf="x?.status === 'Approved'" class="success-badge">success
                                                    </div>
                                                    <div *ngIf="x?.status === 'Decline'" class="rejected-badge">rejected
                                                    </div>
                                                    <div *ngIf="x?.status === 'Pending'" class="rejected-badge">pending
                                                    </div>
                                                </div>
                                            </td>

                                            <td class="p-2">{{ x?.depositId?.paymenttype | uppercase }}</td>
                                            <td class="p-2">{{ x?.createdAt | date:'medium' }}</td>

                                            <td class="p-2">
                                                <span *ngIf="x?.remarks; else blankreason">{{ x?.remarks }}</span>
                                                <ng-template #blankreason>-</ng-template>
                                            </td>
                                            <td class="p-2 text-center">
                                                <svg (click)="openModal(x, showimgModal)" data-bs-toggle="modal"
                                                    data-bs-target="#showimgModal" xmlns="http://www.w3.org/2000/svg"
                                                    width="20" height="20" fill="currentColor" viewBox="0 0 16 16"
                                                    class="cursor-pointer">

                                                    <path
                                                        d="M.5 9.9a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 0 1 1 0v3A2.5 2.5 0 0 1 13.5 16h-11A2.5 2.5 0 0 1 0 13.5v-3a.5.5 0 0 1 .5-.5z" />
                                                    <path
                                                        d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                </svg>
                                            </td>
                                        </tr>
                                        <tr *ngIf="transactions?.length==0">
                                            <td colspan="10" class="text- center">
                                                <div class="norecord">No Record Found!</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>



                        <app-right-side-bar></app-right-side-bar>

                    </div>

                </div>

            </div>

        </div>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
<div class="modal fade" id="showimgModal" tabindex="-1">
    <div>
        <div class="modal-content p-3">
            <!-- Header with close icon -->
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0 text-dark">Upload Screenshot</h5>

                <button type="button" class="btn-close" (click)="modalRef.hide()">
                </button>
            </div>

            <!-- Amount -->
            <p><strong>Amount:</strong> {{ selectedTransaction?.amount }}</p>

            <!-- File Upload -->
            <input type="file" (change)="onFileChange($event)" class="form-control mb-3">

            <!-- Buttons -->
            <div class="d-flex justify-content-end gap-2">
                <button class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()">
                    Cancel
                </button>

                <button class="btn btn-primary" (click)="submit()">
                    Submit
                </button>
            </div>

        </div>
    </div>
</div>
<ng-template #showimgModal>

    <div class="jdus p-3">

        <!-- Header with close icon -->
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0 text-dark">Upload Screenshot</h5>

            <div class="text-right"><a type="button" class="close" (click)="modalRef.hide()">
                    <i class="material-icons" (click)="modalRef.hide()">close</i>
                </a></div>
        </div>

        <!-- Amount -->
        <p><strong>Amount:</strong> {{ selectedTransaction?.amount }}</p>

        <!-- File Upload -->
        <input type="file" (change)="onFileChange($event)" class="form-control mb-3">

        <!-- Buttons -->
        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-secondary cancelbutt" (click)="cancel()">
                Cancel
            </button>

            <button class="btn btn-primary" (click)="submit()">
                Submit
            </button>
        </div>

    </div>


</ng-template>